import { thumbnailImage } from '@/utils'

var moment = require('moment')

function saasSymbolNumberFunc(num, precision = 2, separator) {
  var parts
  // 判断是否为数字
  if (!isNaN(parseFloat(num)) && isFinite(num)) {
    // 把类似 .5, 5. 之类的数据转化成0.5, 5, 为数据精度处理做准, 至于为什么
    // 不在判断中直接写 if (!isNaN(num = parseFloat(num)) && isFinite(num))
    // 是因为parseFloat有一个奇怪的精度问题, 比如 parseFloat(12312312.1234567119)
    // 的值变成了 12312312.123456713
    num = Number(num)
    // 处理小数点位数
    num = (typeof precision !== 'undefined' ? floatBeat(num, precision) : num).toString()
    // 分离数字的小数部分和整数部分
    parts = num.split('.')
    parts[0] = parts[0].toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + (separator || ''))
    return parts.join('.')
  }
  return NaN
}
// 优化数字四舍五入
function floatBeat(num, pz) {
  const str = String(num)
  if (str.includes('.')) {
    const nrr = str.split('.')
    let n = nrr[1]
    n = '0.' + nrr[1]
    if (nrr[1].substr(pz, 1) === 5 && num.toFixed(pz) < num) {
      const an = Number().toFixed(pz) + '1'

      nrr[1] = Number(n) + Number(an)
    } else {
      nrr[1] = Number(n).toFixed(pz)
    }
    const perz = Number(nrr[0]) + Number(nrr[1])
    return perz.toFixed(pz)
  } else {
    return num.toFixed(pz)
  }
}

export default {

  filters: {
    formatDate: (value, format = 'YYYY-MM-DD') => {
      const date = moment(value)
      return date.isValid() ? date.format(format) : '-'
    },
    timeToNow: start => {
      // 计算到今天的时间间隔，格式 n年n月n天
      const x = moment()
      const y = moment(start)
      if (!y.isValid()) {
        return '-'
      }
      const duration = moment.duration(x.diff(y))
      const years = duration.years()
      const months = duration.months()
      const days = duration.days()
      return (years ? `${years}年` : '') + (months ? `${months}个月` : '') + `${days}天`
    },
    saasSymbolNumber: (value, precision, separator) => {
      return saasSymbolNumberFunc(value, precision, separator)
    },
    thumbnailImage
  },
  activated() {
    // 刷新列表页
    if (this.$el.getAttribute && this.$el.getAttribute('class') && String(this.$el.getAttribute('class')).includes('router-box')) {
      if (this.$store.state.menu.keepUpdateList.includes(this.$route.path)) {
        if (this.keepAliveRefresh) {
          this.keepAliveRefresh()
          this.$store.commit('removekeepUpdateListItem', this.$route.path);
        }
      }
    }
  },
  methods: {
    // 跳转时刷新列表页
    keepUpdate(url) {
      this.$store.commit('setKeepUpdateList', url);
    },
    // 关闭当前缓存页
    closeCurTab() {
      this.$store.commit('removeRouter', this.$route);
    },
    // 验证权限
    authPromise(value) {
      if (this.$store.state.user.authorityList && this.$store.state.user.authorityList.length) {
        return this.authList.includes(`shop-management::${value}`)
      }
    },
    /**
     * @description 限制只能输入数字
     * @param event:obj 事件对象
     */
    onInputNumber(event, bit = 0, target) {
      this.mixinRegNum(event, bit)
    },
    /**
     * @description 数字过滤
     * @param e: 事件对象
     * @param min: 事件对象最小值
     * @param max: 事件对象最大值
     */

    mixinRegNum(e, bit, min = false, max = false) {
      let value = (e.target && e.target.value) || e
      if (bit == 0) {
        value = value.replace(/[^\d]/g, '')
      } else if (bit == 2) {
        value = value.replace(/[^\d.]/g, '') // 清除"数字"和"."以外的字符
        value = value.replace(/^\./g, '') // 验证第一个字符是数字
        value = value.replace(/\.{2,}/g, '.') // 只保留第一个, 清除多余的
        value = value
          .replace('.', '$#$')
          .replace(/\./g, '')
          .replace('$#$', '.')
        value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3') // 只能输入两个小数
        if (value.match(/^0+[0-9]/)) {
          value = value.substring(value.match(/^0+[0-9]/)[0].length - 1)
        }
      } else if (bit == -1) {
        // 不限位数
        value = value.replace(/[^\d.]/g, '') // 清除"数字"和"."以外的字符
      }
      if ((min || min === 0) && value < min) value = min
      if ((max || max === 0) && value > max) value = max
      if (e.target) {
        e.target.value = value
      }
      return value
    },
    /**
     * @desc 数字格式化
     * @param  value - 处理数字
     * @param  precision - 小数点位数
     * @param separator - 分隔号不传为''
     */
    saasSymbolNumberMethod(value, precision, separator) {
      return saasSymbolNumberFunc(value, precision, separator)
    },
    thumbnailImage: thumbnailImage,
    focusSelect(e) {
      e.target.select()
    }
  },
  destroyed() {
  },
  computed: {
    hasBindData() {
      return this.$store.state.user.hasBindData || {}
    },
    authList() {
      return this.$store.state.user.authorityList.filter(item => item.actionType === 2 && item.isShow === 1).map(item => item.actionCode)
    }
  }
}
